module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1011-30b86ffbaca8a5ad9d45728febff7abe.png";